(function () {
  function initFooter(root) {
    const footer = root.querySelector('.bjp-footer');
    if (!footer || footer.dataset.ready) return;
    footer.dataset.ready = 'true';
    const mobile = window.matchMedia('(max-width: 767px)');
    const columns = footer.querySelectorAll('.bjp-footer-column');
    function sync() {
      columns.forEach(function (column) {
        column.open = !mobile.matches;
        column.querySelector('summary').tabIndex = mobile.matches ? 0 : -1;
      });
    }
    columns.forEach(function (column) {
      column.querySelector('summary').addEventListener('click', function (event) {
        if (!mobile.matches) event.preventDefault();
      });
    });
    mobile.addEventListener('change', sync);
    sync();
  }
  initFooter(document);
  document.addEventListener('shopify:section:load', function (event) { initFooter(event.target); });
})();
